import { useTranslation } from '@mint-lib/i18n';
import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

import { ImportModalBody } from './components/ImportModalBody.jsx';
import { ImportModalFooter } from './components/ImportModalFooter.jsx';
import { useActivitySelection } from './useActivitySelection.js';
import { useImportPlan } from './useImportPlan.js';

type Props = {
  handleOpenChange: (isOpen: boolean) => void;
};

export const DialogContentImport = ({ handleOpenChange }: Props) => {
  const { t } = useTranslation('@myn/planning_v2');

  const {
    activities,
    selectedActivityId,
    onActivityChange,
    activity,
    isSelectionIncomplete,
  } = useActivitySelection();

  const {
    activeView,
    fileUploaderRef,
    setFiles,
    handleFileUpload,
    isPending,
    isImportButtonDisabled,
    isDownloadTemplateDisabled,
    handleDownloadTemplateButton,
    handleUploadNewFileButton,
    handleDownloadErrorLog,
    handleImport,
  } = useImportPlan({ handleOpenChange, activity, isSelectionIncomplete });

  return (
    <DialogRoot size="m">
      <DialogHeader data-dd-action-name="Import activity modal: close">
        <DialogTitle>{t('Import activity')}</DialogTitle>
      </DialogHeader>

      <DialogContent>
        <div className="flex w-full flex-col p-1">
          <ImportModalBody
            activeView={activeView}
            fileUploaderRef={fileUploaderRef}
            setFiles={setFiles}
            handleFileUpload={handleFileUpload}
            activities={activities}
            selectedActivityId={selectedActivityId}
            onActivityChange={onActivityChange}
          />
        </div>
      </DialogContent>

      <DialogFooter>
        <ImportModalFooter
          activeView={activeView}
          isPending={isPending}
          isImportButtonDisabled={isImportButtonDisabled}
          isDownloadTemplateDisabled={isDownloadTemplateDisabled}
          handleDownloadTemplateButton={handleDownloadTemplateButton}
          handleUploadNewFileButton={handleUploadNewFileButton}
          handleDownloadErrorLog={handleDownloadErrorLog}
          handleImport={handleImport}
          handleOpenChange={handleOpenChange}
        />
      </DialogFooter>
    </DialogRoot>
  );
};
